import React, { useState, useEffect } from 'react';
import NotificationWrapper from '../../../components/AppSettings/NotificationWrapper';
import { useGetNotification, usePostNotification } from '../hooks/api/templatesNotificationApi';
import { useIntl } from 'react-intl';
import useAppContext from '../../../hooks/context/useAppContext';

const notificationTypeLEnum = {
  dayly: {
    id: 1,
  },
  weekly: {
    id: 2,
  },
  price: {
    id: 3,
  },
  createTransaction: {
    id: 4,
  },
  purchaseEnd: {
    id: 5,
  },
};

const getInitValues = (id) => {
  return {
    sms: false,
    email: false,
    notificationTypeId: id,
  };
};

const transformObjectFromDatabase = (data, object) => {
  if (data.some((item) => item?.notificationChannel.id === 1)) {
    Object.assign(object, { email: true });
  }
  if (data.some((item) => item?.notificationChannel.id === 2)) {
    Object.assign(object, { sms: true });
  }

  return object;
};

const transformObjectToDatabase = (notificationTypeId, object) => {
  const toSend = [];
  if (object.sms && notificationTypeId !== notificationTypeLEnum?.weekly?.id) {
    toSend.push({
      notificationType: { id: notificationTypeId },
      notificationChannel: { id: 2 },
    });
  }
  if (object.email) {
    toSend.push({
      notificationType: { id: notificationTypeId },
      notificationChannel: { id: 1 },
    });
  }

  return toSend;
};

const TemplatesNotification = () => {
  const { getNotification: getDayly, data: daylyData, loading: getLoadingDayly } = useGetNotification();
  const { getNotification: getWeekly, data: weeklyData, loading: getLoadingWeekly } = useGetNotification();
  const { getNotification: getcreateTransaction, data: createTransactionData, loading: getLoadingTransaction } = useGetNotification();
  const { getNotification: getpurchaseEnd, data: purchaseEndData, loading: getLoadingNotification } = useGetNotification();

  const { postNotification, loading: postNotificationLoading, error: postNotificationError } = usePostNotification();

  const [dayly, setDayly] = useState(getInitValues());
  const [weekly, setWeekly] = useState(getInitValues());
  const [createTransaction, setCreateTransaction] = useState(getInitValues());
  const [purchaseEnd, setPurchaseEnd] = useState(getInitValues());
  const intl = useIntl();
  const { setBreadCrumbs, getUser } = useAppContext();
  const user = getUser();

  const templatesTitle = intl.formatMessage({ id: 'app.notification.templates' });

  useEffect(() => {
    setBreadCrumbs(`${templatesTitle}`);
  }, [setBreadCrumbs, templatesTitle]);

  const sendHandler = (notificationTypeId) => {
    let transformObject = null;
    switch (notificationTypeId) {
      case 1:
        transformObject = dayly;
        break;
      case 2:
        transformObject = weekly;
        break;
      case 4:
        transformObject = createTransaction;
        break;
      case 5:
        transformObject = purchaseEnd;
        break;
      default:
        break;
    }
    const body = transformObjectToDatabase(notificationTypeId, transformObject);
    postNotification(body, notificationTypeId);
  };

  useEffect(() => {
    (async () => {
      await getDayly(notificationTypeLEnum.dayly.id);
    })();
    (async () => {
      await getWeekly(notificationTypeLEnum.weekly.id);
    })();
    (async () => {
      await getcreateTransaction(notificationTypeLEnum.createTransaction.id);
    })();
    (async () => {
      await getpurchaseEnd(notificationTypeLEnum.purchaseEnd.id);
    })();
  }, [getDayly, getWeekly, getcreateTransaction, getpurchaseEnd]);

  useEffect(() => {
    if (createTransactionData) {
      setCreateTransaction(transformObjectFromDatabase(createTransactionData, getInitValues(notificationTypeLEnum.createTransaction.id)));
    }
    if (daylyData) {
      setDayly(transformObjectFromDatabase(daylyData, getInitValues(notificationTypeLEnum.dayly.id)));
    }
    if (weeklyData) {
      setWeekly(transformObjectFromDatabase(weeklyData, getInitValues(notificationTypeLEnum.weekly.id)));
    }
    if (purchaseEndData) {
      setPurchaseEnd(transformObjectFromDatabase(purchaseEndData, getInitValues(notificationTypeLEnum.purchaseEnd.id)));
    }
  }, [createTransactionData, daylyData, weeklyData, purchaseEndData]);

  const notifications = {
    dayly,
    weekly,
    createTransaction,
    purchaseEnd,
    postNotificationLoading,
    postNotificationError,
    getLoadingDayly,
    getLoadingWeekly,
    getLoadingTransaction,
    getLoadingNotification,
    notificationTypeLEnum,
    user,
  };

  const handlers = {
    setDayly,
    setWeekly,
    setCreateTransaction,
    setPurchaseEnd,
    sendHandler,
  };

  return (
    <>
      <NotificationWrapper notifications={notifications} handlers={handlers} />
    </>
  );
};

TemplatesNotification.propTypes = {};

export default TemplatesNotification;
